<template>
  <div :class="wrapperClass">
    <div :class="textWrapperClass">
      <div :class="iconClass">
        <img :src="iconSrc" alt="info-circle" width="16" height="16" />
      </div>
      <span :class="labelClass">{{ infoData?.label || '' }}</span>
    </div>
    <slot name="action"></slot>
  </div>
</template>

<script>
  import warningCircle from '@/assets/images/vm/warning-circle.svg'
  import infoCircle from '@/assets/images/vm/info-circle.svg'

  export default {
    name: 'BomValidationResultsElementsInfo',
    props: {
      infoData: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },
    data: () => ({
      mainClassName: 'validation-results-elements-info__wrapper',
      icons: {
        warn: warningCircle,
        info: infoCircle
      }
    }),
    computed: {
      wrapperClass() {
        return [this.mainClassName, this.infoData?.key]
      },
      iconClass() {
        return `${ this.mainClassName }--info-icon`
      },
      labelClass() {
        return `${ this.mainClassName }--info-label`
      },
      textWrapperClass() {
        return `${ this.mainClassName }--info-wrapper`
      },
      iconSrc() {
        return this.icons[this.infoData?.key] ?? ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .validation-results-elements-info {
    &__wrapper {
      display: flex;
      height: 40px;
      padding: 10px;
      align-items: center;
      align-self: stretch;
      margin-top: 1em;
      justify-content: space-between;

      &--info-icon {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      &--info-wrapper {
        display: flex;
        flex-direction: row;
        gap: 10px;
      }

      &--info-label {
        font-family: $mi-typography-font-family;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        color: #303c49;
      }
    }
  }

  .warn {
    border: 2px solid $mi-yellow-800;
    background: $mi-yellow-50;
  }

  .info {
    border: 2px solid $mi-blue-800;
    background: $mi-blue-50;
  }
</style>
